module.exports = function getResource(label, vars = []) {
    let resources = {
        unfollow: 'Unfollow',
        follow: 'Follow',
        sendMessage: 'Send Message'
    };
    return resources[label];
};
